"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _uxUtils = require("@site/ux-utils");
var _2 = _interopRequireDefault(require("."));
var _utils = require("../utils");
const SpinCardRecommendationsContainer = ({
  numberOfCards,
  results,
  ctaProps,
  options = {},
  enableDynamicFontScaling,
  customClassName,
  PriceBlock,
  language,
  AddToCartButton,
  hideIcon,
  isConversationalSearch,
  dataEid
}) => {
  const {
    isMobile
  } = (0, _uxUtils.useDeviceType)();
  const {
    showFreeIndicator,
    maxSpins = 40
  } = options;
  const cardsArray = new Array(Math.min(numberOfCards, results?.RecommendedDomains?.length || numberOfCards)).fill();
  const domains = (0, _utils.transformSpinData)({
    findResponse: results,
    showFreeIndicator,
    maxSpins
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "spins-card-recommendations-container",
    className: (0, _classnames.default)('spins-cards-container', {
      'd-grid': !isMobile
    })
  }, cardsArray.map((_, i) => {
    const domain = domains?.[i];
    const product = domains?.[i]?.product;
    return /*#__PURE__*/_react.default.createElement(_2.default, {
      key: `${domain?.Fqdn}_${i}`,
      domain: domain,
      product: product,
      ctaProps: ctaProps,
      options: options,
      enableDynamicFontScaling: enableDynamicFontScaling,
      PriceBlock: PriceBlock,
      language: language,
      AddToCartButton: AddToCartButton,
      hideIcon: hideIcon,
      isConversationalSearch: isConversationalSearch,
      dataEid: dataEid,
      customClassName: customClassName
    });
  }));
};
SpinCardRecommendationsContainer.propTypes = {
  isMobile: _propTypes.default.bool,
  numberOfCards: _propTypes.default.number,
  results: _propTypes.default.object,
  ctaProps: _propTypes.default.object,
  options: _propTypes.default.object,
  enableDynamicFontScaling: _propTypes.default.bool,
  PriceBlock: _propTypes.default.elementType,
  language: _propTypes.default.object,
  AddToCartButton: _propTypes.default.elementType,
  hideIcon: _propTypes.default.bool,
  isConversationalSearch: _propTypes.default.bool,
  dataEid: _propTypes.default.string,
  customClassName: _propTypes.default.string
};
var _default = exports.default = SpinCardRecommendationsContainer;